import { render, staticRenderFns } from "./CreateMasterAccount.vue?vue&type=template&id=4bf6803a&scoped=true"
import script from "./CreateMasterAccount.vue?vue&type=script&lang=js"
export * from "./CreateMasterAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateMasterAccount.vue?vue&type=style&index=0&id=4bf6803a&prod&lang=scss&scoped=true"
import style1 from "./CreateMasterAccount.vue?vue&type=style&index=1&id=4bf6803a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf6803a",
  null
  
)

export default component.exports